<template>
  <a-drawer
    title="访视分组"
    :width="1000"
    @close="handleCancel"
    :visible="visible">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :span="8">
            <a-form-item label="分组名称">
              <a-input placeholder="请输入分组名称" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="8">
            <a-form-item label="项目ID">
              <a-input placeholder="请输入项目ID" v-model="queryParam.projectId"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="8">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"

        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>

        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <projectVisitFormGroup-modal ref="modalForm" @ok="modalFormOk" :projectId="projectId"></projectVisitFormGroup-modal>
  </a-drawer>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import ProjectVisitFormGroupModal from './modules/ProjectVisitFormGroupModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: "ProjectVisitFormGroupList",
    mixins:[JeecgListMixin],
    components: {
      ProjectVisitFormGroupModal
    },
    data () {
      return {
        description: '访视表单的分组管理页面',
        visible:false,
        projectId:'',
        // 表头
        columns: [
		   {
            title: '分组名称',
            align:"center",
            dataIndex: 'name'
           },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/project/projectVisitFormGroup/list",
          delete: "/project/projectVisitFormGroup/delete",
       },
        disableMixinCreated:true,
    }
  },
  computed: {
  },
    methods: {
      view(projectId){
        this.projectId = projectId
        this.baseQueryParam={
          projectId:projectId
        }
        this.loadData()
      },
      handleCancel(){
        this.visible = false
      },
      loadDataCallback(){
        this.visible = true
      },
      handleOk(){
        this.handleCancel()
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>